'use client';

import {
  HomeLandingSections,
  HomeStoriesSection,
  HomeCommunitySection,
  HomeVoicesSection,
  HomeAboutSection,
} from '@/components/homePageSections';

import { useState } from 'react';
import Header from '@/components/Header';
import HomeHeroSection from '@/components/HomeHeroSection';

export default function YogMaratha() {
  const [openFAQ, setOpenFAQ] = useState<number | null>(null);

  return (
    <div className="bg-white">
      {/* Transparent Header */}
      <Header variant="transparent" />

      <HomeHeroSection
        title="मराठा वधू वरांसाठी"
        subtitle="महाराष्ट्रातील अग्रणी विवाहसंस्था"
        trackingSource="yog_maratha"
      />

      <HomeLandingSections />

      <HomeStoriesSection />

      <HomeCommunitySection />

      <HomeVoicesSection />

      <HomeAboutSection />

      {/* FAQ Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
            Frequently Asked Questions
          </h2>
          <div className="max-w-4xl mx-auto">
            <div className="space-y-4">
              {[
                {
                  question: "What is Maratha Marriage?",
                  answer: "For Maratha marriage register free through trusted Marathi Vadhu Var Suchak app to search Maratha grooms and brides. You can register free on MarathiVadhuVarSuchak.com."
                },
                {
                  question: "Which is the best matrimonial site for Maratha?",
                  answer: "MarathiVadhuVarSuchak.com is the best matrimonial site for Maratha grooms and brides."
                },
                {
                  question: "How to do Maratha grooms and bride search online?",
                  answer: "First you have to register free through MarathiVadhuVarSuchak.com matrimonial site. Then Maratha grooms and brides can search profile online."
                },
                {
                  question: "How to search Maratha Samaj Goa based profiles?",
                  answer: "Maratha Vadhu Var first needs to register on MarathiVadhuVarSuchak.com Marathi matrimony. Then you can search profiles from Goa."
                },
                {
                  question: "How to search Maratha Samaj Kagal based profiles?",
                  answer: "Marathi Vadhu Var can register free through MarathiVadhuVarSuchak.com Marathi matrimony. After approval you can search Maratha profiles from Kagal."
                },
                {
                  question: "How to search Maratha Grooms online?",
                  answer: "Maratha brides first need to register free on MarathiVadhuVarSuchak.com site. After approval you can search Maratha grooms profile online."
                },
                {
                  question: "Which is the best Maratha matrimony?",
                  answer: "MarathiVadhuVarSuchak.com matrimony is the best matrimony for Maratha grooms and brides to register free."
                },
                {
                  question: "How to search Maratha Kolhapur based profiles?",
                  answer: "Visit MarathiVadhuVarSuchak.com Marathi matrimony for free registration. Then you can search Maratha grooms and brides profile from Kolhapur."
                },
                {
                  question: "How to search Maratha Pune city-based profiles?",
                  answer: "Visit MarathiVadhuVarSuchak.com matrimony to register free. Then you can search Maratha grooms and brides profile from Pune."
                },
                {
                  question: "How to search Maratha Satara city-based profiles?",
                  answer: "Visit MarathiVadhuVarSuchak.com matrimonial site for free registration. Then you can search Maratha grooms and brides profile from Satara."
                },
                {
                  question: "How to search Maratha Sangli based profiles?",
                  answer: "Visit MarathiVadhuVarSuchak.com matrimonial site to register free. Then users can search Maratha grooms and brides profile from Sangli."
                },
                {
                  question: "How to search Maratha samaj Divorcee grooms?",
                  answer: "Maratha brides first need to register free on MarathiVadhuVarSuchak.com site. Then Maratha brides can search Maratha grooms."
                },
                {
                  question: "How to search Maratha samaj brides?",
                  answer: "Maratha grooms first need to register free on MarathiVadhuVarSuchak.com site. Then Maratha grooms can search Maratha brides."
                },
                {
                  question: "How to search educated Maratha Vadhu Var online?",
                  answer: "You can Maratha Vadhu Var online through MarathiVadhuVarSuchak.com Marathi matrimonial site."
                },
                {
                  question: "How to search educated Maratha Vadhu online?",
                  answer: "You can Maratha Vadhu online through MarathiVadhuVarSuchak.com Marathi matrimony site."
                }
              ].map((faq, index) => (
                <div key={index} className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm">
                  <button
                    onClick={() => setOpenFAQ(openFAQ === index ? null : index)}
                    className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-gray-50 transition-colors"
                  >
                    <h3 className="text-lg font-semibold text-gray-900">
                      {faq.question}
                    </h3>
                    <svg
                      className={`w-5 h-5 text-gray-500 transition-transform duration-300 ${
                        openFAQ === index ? 'rotate-180' : ''
                      }`}
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>
                  <div
                    className={`px-6 transition-all duration-300 ease-in-out ${
                      openFAQ === index ? 'pb-4 max-h-96 opacity-100' : 'max-h-0 opacity-0 overflow-hidden'
                    }`}
                  >
                    <div className="text-gray-600 leading-relaxed py-3">
                      <p className="mb-3">{faq.answer}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Yog Maratha matrimony for Maratha Community Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto text-center">
            <h2 className="text-3xl font-bold text-gray-900 mb-8">
            What is the importance of 'Yog' in Maratha community marriage?
            </h2>
            <p className="text-gray-700 leading-relaxed" style={{ fontSize: '1.11rem' }}>
            Finding the perfect life partner within the Maratha community goes far beyond matching horoscopes - it is a sacred union guided by tradition, family values, and the divine concept of 'Yog'. In Maratha matrimony, 'Yog' refers to the auspicious cosmic alignment between two individuals, believed to determine the harmony, prosperity, and longevity of their married life. Families consult experienced Jyotishis to assess the Yog between prospective Vadhu and Var, ensuring compatibility across Kundali, Nakshatra, and Gotra. A strong and favorable Yog is considered a blessing that brings together not just two souls, but two families, deepening roots in Maratha culture and heritage. At MarathiVadhuVarSuchak.com, we honor this timeless tradition by connecting Maratha Vadhu Var profiles where both astrological Yog and personal compatibility are thoughtfully considered. Begin your journey toward a blessed and prosperous Maratha Vivah - because the right Yog makes all the difference.
            </p>
          </div>
        </div>
      </section>

    </div>
  );
}
